/**

 * DEVELOPER DOCUMENTATION & INFO
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/*
Also Bought Custom JS
====================================*/
let hasJquery = false;
if (window.jQuery) {
  hasJquery = true;
} else if (window.Checkout && window.Checkout.$) {
  hasJquery = true;
} else {
  console.log('Also Bought error: No jQuery defined');
}
if(hasJquery){

  //default variant selection
  function selectVariantOverride() {
    console.log('test');
    $('#AddToCart').removeAttr('disabled');
    $('.shopify-product-form .loader-button__text').text('Add to Cart');
  }

  //check mini cart for recommendations
  $(document).ready(function() {
    /*
    setTimeout(function() {
      checkMiniCartRecommendations();     
    },3000);
    //also bought add to cart
    setTimeout(function() {
      //??
    });
    */
    //pdp form event
    $('.rokform-also-bought .plug-product-upsell-item__add-btn').on('click',function(e) {
      console.log('also bought');
      e.preventDefault();
      const variantId = parseInt($(this).data('variant-id'));
      const variantIdString = variantId.toString();
      const elem = $(this);
      
      if($(this).hasClass('added')){
        //remove from cart
        console.log('remove item from cart');

          let data = {"id" : variantIdString, "quantity" : 0 };
          $.ajax({
            url: '/cart/change.js',
            type: 'post',
            dataType: 'json',
            data: data,
            success: function (cart){
              console.log('removed');
              //display added
              elem.html('+ Add').removeClass('added');
  
              //event docs in custom.js don't work
              /*
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
              */
  
              //open status banner
              //document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              //  bubbles: true
              //}));
              document.documentElement.dispatchEvent(new CustomEvent("cart-notification:show", {
                bubbles: true,
                cancelable: true,
                detail: {
                  status: "error",
                  error: "Item removed from cart"
                }
              }));
  
              //update cart
              jQuery.getJSON('/cart.js', function(cart) {
                 // now have access to Shopify cart object
                 document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true,
                    detail: {
                      cart: cart,
                      //openMiniCart: window.themeVariables.settings.cartType === "drawer" && this.closest(".drawer") === null
                    }
                  }));
                //checkMiniCartRecommendations();
              });
            }
        });

        /*
        document.documentElement.dispatchEvent(new CustomEvent("cart-notification:show", {
          bubbles: true,
          cancelable: true,
          detail: {
            status: "error",
            error: "Item Removed From Cart"
          }
        }));
        $(this).removeClass('added').html('+ Add');
        */
      } else {
        $.ajax({
            url: '/cart/add.js',
            type: 'post',
            dataType: 'json',
            data: {
              quantity: 1,
              id: variantId
            },
            success: function (cart){
              console.log('added');
              //display added
              elem.html('&#x2713;').addClass('added');
  
              //event docs in custom.js don't work
              /*
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
              */
  
              //open status banner
              //document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              //  bubbles: true
              //}));
              document.documentElement.dispatchEvent(new CustomEvent("cart-notification:show", {
                bubbles: true,
                cancelable: true,
                detail: {
                  status: "success",
                  error: "Error"
                }
              }));
  
              //update cart
              jQuery.getJSON('/cart.js', function(cart) {
                 // now have access to Shopify cart object
                 document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true,
                    detail: {
                      cart: cart,
                      //openMiniCart: window.themeVariables.settings.cartType === "drawer" && this.closest(".drawer") === null
                    }
                  }));
                //checkMiniCartRecommendations();
              });
            }
        });        
      }

    });
    //mini cart event
    $('#mini-cart').on('click','.rokform-also-bought .plug-product-upsell-item__add-btn',function() {
      const variantId = parseInt($(this).data('variant-id'));
      const elem = $(this);
      $.ajax({
          url: '/cart/add.js',
          type: 'post',
          dataType: 'json',
          data: {
            quantity: 1,
            id: variantId
          },
          success: function (cart){
            //display added
            elem.html('&#x2713;').addClass('added');
            
            //update cart
            jQuery.getJSON('/cart.js', function(cart) {
               // now have access to Shopify cart object
               document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true,
                  detail: {
                    cart: cart,
                    //openMiniCart: window.themeVariables.settings.cartType === "drawer" && this.closest(".drawer") === null
                  }
                }));
              checkMiniCartRecommendations();
            });
          }
      });
    });
  });
}

function checkMiniCartRecommendations() {
  console.log('checkMiniCartRecommendations');
  return; //old rec tool
  setTimeout(function() {
      if(
        $('.shopify-section--main-product').length > 0
      ){
        //clone pdp form to mini cart
        let elemToCopy = $('.shopify-section--main-product .rokform-also-bought').first().clone();
        let htmlToCopy = $('.shopify-section--main-product .rokform-also-bought').first().clone();
        $('#mini-cart .drawer__content .rokform-also-bought').html('').append(htmlToCopy);

        //build mobile recs UI
        if(
          $('#plug-product-upsell-items .plug-product-upsell-items__title').length
          &&
          $('#plug-product-upsell-items .plug-product-upsell-items__title').text() != ''
        ) {
          //rec title
          $('.drawer__content .mini-cart__recommendations-heading').text($('#plug-product-upsell-items .plug-product-upsell-items__title').text());
          //rec loop
          console.log(rokProdRecs);
          $('.drawer__content .mini-cart__recommendations-list').html('');
          for (let i = 0; i < rokProdRecs.length; i++) {
            console.log('double? '+rokProdRecs[i].handle);
            let html = '';
            html += '                    <product-item class="product-item ">'+"\n";
            html += '                      <div class="product-item__image-wrapper ">'+"\n";
            html += '                        <a'+"\n";
            html += '                          href="/products/"'+rokProdRecs[i].handle+"\n";
            html += '                          data-instant=""'+"\n";
            html += '                          class="product-item__aspect-ratio aspect-ratio "'+"\n";
            html += '                          style="padding-bottom: 100.0%; --aspect-ratio: 1.0"'+"\n";
            html += '                          data-uw-rm-brl="false"'+"\n";
            html += '                          ><img'+"\n";
            html += '                            src="'+rokProdRecs[i].image+'"'+"\n";
            html += '                            alt="Rokform Universal Phone Adapter"'+"\n";
            html += '                            loading="lazy"'+"\n";
            //html += '                            sizes="(max-width: 740px) 65px, 92px"'+"\n";
            html += '                            class="product-item__primary-image"'+"\n";
            //html += '                            data-media-id="3940760551493"'+"\n";
            //html += '                            data-uw-rm-ima-original="rokform universal phone adapter"'+"\n";
            html += '                            width="1000"'+"\n";
            html += '                            height="1000"'+"\n";
            html += '                          >'+"\n";
            html += '                        </a>'+"\n";
            html += '                      </div>'+"\n";

            html += '                      <div class="product-item__info  text--small">'+"\n";
            html += '                        <div class="product-item-meta">'+"\n";
            html += '                          <a'+"\n";
            html += '                            href="/products/'+rokProdRecs[i].handle+"\n";
            html += '                            data-instant=""'+"\n";
            html += '                            class="product-item-meta__title"'+"\n";
            html += '                            data-uw-rm-brl="false"'+"\n";
            html += '                            >'+rokProdRecs[i].title+'</a'+"\n";
            html += '                          >'+"\n";

            html += '                          <div class="product-item-meta__price-list-container">'+"\n";
            html += '                            <div class="price-list price-list--centered">'+"\n";
            html += '                              <span class="price">'+"\n";
            html += '                                <span class="visually-hidden">Sale price</span'+"\n";
            html += '                                ><span class="money" data-uw-rm-sr="">'+rokProdRecs[i].price+'</span></span'+"\n";
            html += '                              >'+"\n";
            html += '                            </div>'+"\n";
            html += '                          </div>'+"\n";
            html += '                        </div>'+"\n";
            html += '                        <div class="product-item__cta-wrapper">'+"\n";
            html += '                          <form'+"\n";
            html += '                            method="post"'+"\n";
            html += '                            action="/cart/add"'+"\n";
            //html += '                            id="product_form_mini-cart__9320738183_0"'+"\n";
            html += '                            accept-charset="UTF-8"'+"\n";
            html += '                            class="shopify-product-form"'+"\n";
            html += '                            enctype="multipart/form-data"'+"\n";
            html += '                            is="product-form"'+"\n";
            html += '                         >'+"\n";
            html += '                            <input type="hidden" name="form_type" value="product"'+"\n";
            html += '                            ><input type="hidden" name="utf8" value="✓"><input type="hidden" name="quantity" value="1">'+"\n";
            html += '                            <input type="hidden" name="id" value="'+rokProdRecs[i].varId+'">'+"\n";
            html += '                            <button type="submit" class="product-item__link link text--subdued" data-uw-rm-form="submit">'+"\n";
            html += '                              + Add to cart'+"\n";
            html += '                            </button>'+"\n";
            html += '                          </form>'+"\n";
            html += '                        </div>'+"\n";
            html += '                      </div>'+"\n";
            html += '                    </product-item>'+"\n";
            $('.drawer__content .mini-cart__recommendations-list').append(html);
          }
        }
      }     
  },1000);
}

/*
Variant Image Switcher
====================================*/

document.addEventListener('variant:changed', function(event) {
  let variant = event.detail.variant; // Gives you access to the whole variant details
  console.log(variant);
  /*
  console.log(meta);
  if(
    meta.hasOwnProperty('product')
    &&
    meta.product.hasOwnProperty('variants')
  ) {
    console.log('pass');
  }
  */
  //let thumbnails = document.getElementById("foo").getElementsByClassName("bar")
  //$('product-media .product__media-nav button:eq(3)').trigger('click');
  $('product-media .product__media-nav img').each(function() {
    //console.log($(this).attr('alt'));
    //$(this).css('border','3px solid green');
    if(variant.option1 == $(this).attr('alt')){
      console.log('find '+$(this).attr('alt')+' and click');
      $(this).closest('button').trigger('click');
      return;
    }
  });
});
